import { useMemo } from 'react'

import { Shimmer } from '@wartek-id/shimmer'

import { PengelolaanKinerjaTimeline } from 'app/KinerjaShared/components/PengelolaanKinerjaTimeline'
import KinerjaSidebar from 'app/KinerjaShared/components/KinerjaSidebar'
import { PeriodikTimKinerjaCard } from 'app/KinerjaAsnSwastaPage/components/PeriodikTimKinerjaCard'
import { PeriksaPerencanaanPegawaiCard } from 'app/KinerjaShared/components/PeriksaPerencanaanPegawaiCard'
import { useAPIPelaksanaanSchools } from 'api/kinerja/useAPIKinerja'
import { PenilaianKinerjaPegawaiCard } from 'app/KinerjaShared/components/PenilaianKinerjaPegawaiCard'
import CardReferensiPenilaian from 'app/KinerjaPage/pages/PelaksanaanV2/CardReferensiPenilaian'
import CardReferensi from 'app/KinerjaPage/components/CardReferensi'
import { PENGELOLAAN_KINERJA_KS_PENILAI_PATH } from 'app/KinerjaShared/constants/path'
import { TahapPenilaianCard } from 'app/KinerjaShared/components/TahapPenilaianCard'
import { MulaiPeriodeCard } from 'app/KinerjaShared/components/MulaiPeriodeCard'

export function Homepage() {
  // -----------------------------------------
  // Get school list
  // -----------------------------------------
  const { data: schoolsData, isLoading: isSchoolsLoading } =
    useAPIPelaksanaanSchools({
      options: {
        staleTime: 60 * 60 * 1000, // 1 hour
      },
    })

  const swastaSchools = useMemo(() => {
    return (
      schoolsData?.data?.filter((school) => {
        const isSwasta = school.statusSatuanPendidikan === 'SWASTA'
        const isSpnf =
          school.role === 'KS_PLT_SPNF' || school.role === 'KS_DEFINITIF_SPNF'

        return isSwasta && !isSpnf
      }) || []
    )
  }, [schoolsData])

  return (
    <div className="flex w-full min-h-screen">
      <div className="flex-shrink-0 min-h-full">
        <div className="w-64">{/* Sentinel element for sidebar spacing */}</div>
        <KinerjaSidebar activeMenu="ks-tim-kinerja" sticky />
      </div>
      <div className="w-full gap-4 p-6 space-y-6">
        <MulaiPeriodeCard
          schools={swastaSchools}
          pegawaiLabel="Guru"
          atasanLabel="Tim Kerja (Pengawas Sekolah)"
        />

        <TahapPenilaianCard />

        {isSchoolsLoading ? (
          <>
            <Shimmer className="!h-40 !w-full block" />
            <Shimmer className="!h-40 !w-full block" />
          </>
        ) : (
          <>
            <PeriksaPerencanaanPegawaiCard
              schools={swastaSchools}
              pegawaiLabel="Guru"
              badgeText="Khusus Kepala Sekolah"
              resolveNextPath={(school) =>
                `${PENGELOLAAN_KINERJA_KS_PENILAI_PATH}/periksa/${school.npsn}`
              }
            />
            <PenilaianKinerjaPegawaiCard
              schools={swastaSchools}
              pegawaiLabel="Guru"
              badgeText="Khusus Kepala Sekolah"
              resolveNextPath={(school) =>
                `${PENGELOLAAN_KINERJA_KS_PENILAI_PATH}/penilaian-kinerja/${school.npsn}`
              }
            />
          </>
        )}

        <PeriodikTimKinerjaCard />

        <CardReferensiPenilaian />

        <PengelolaanKinerjaTimeline
          timeline={[
            {
              title: 'Januari',
              steps: ['Perencanaan Kinerja'],
            },
            {
              title: 'Februari - November',
              steps: [
                'Persiapan Praktik Kinerja',
                'Pelaksanaan Observasi Praktik Kinerja',
                'Pelaksanaan Tindak Lanjut Praktik Kinerja',
              ],
            },
            {
              title: 'Desember',
              steps: ['Rekomendasi Predikat Kinerja'],
            },
          ]}
        />

        <CardReferensi />
      </div>
    </div>
  )
}
